import axios from "axios";
import config from "../config/config";
import { getHeaders } from "./apiHelper";

const API_URL = config.API_URL; 

export const getCompensation = async () => {
  const response = await axios.get(`${API_URL}compensation`, { headers: getHeaders() });
  return response.data;
};

export const storeCompensation = async (compensation) => {
  const isMultipart = typeof FormData !== 'undefined' && compensation instanceof FormData;
  const response = await axios.post(`${API_URL}compensation`, compensation, { headers: getHeaders(isMultipart) });
  return response.data;
};

export const getDetailCompensation = async (id) => {
  const response = await axios.get(`${API_URL}compensation/${id}`, { headers: getHeaders() });
  return response.data;
};

export const deleteCompensation = async (id) => {
  const response = await axios.delete(`${API_URL}compensation/${id}`, { headers: getHeaders() });
  return response.data;
};

export const updateCompensation = async (id, data) => {
  const isMultipart = typeof FormData !== 'undefined' && data instanceof FormData;
  if (isMultipart) {
    if (!data.has('_method')) {
      data.append('_method', 'PUT');
    }
    const response = await axios.post(`${API_URL}compensation/${id}`, data, { headers: getHeaders(true) });
    return response.data;
  }
  const response = await axios.put(`${API_URL}compensation/${id}`, data, { headers: getHeaders(false) });
  return response.data;
};
